// src/pages/ReportPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { reportPerson } from '../services/api';

export default function ReportPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name:'', age:'', gender:'Femenino', location:'', lastSeen:'', lastSeenTime:'', description:'', contact:'', contactName:'' });
  const [loading, setLoading] = useState(false);
  const [done,    setDone]    = useState(null);
  const [error,   setError]   = useState('');

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.age || !form.location || !form.contact) {
      setError('Completa los campos obligatorios (*)'); return;
    }
    setLoading(true); setError('');
    try {
      const res = await reportPerson(form);
      setDone(res.caseId || `ESP-2025-${Math.floor(Math.random()*9000+1000)}`);
    } catch {
      setError('Error al enviar. Inténtalo de nuevo.');
    }
    setLoading(false);
  };

  const F = ({ label, required, children }) => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display:'block', fontSize:11, color:'#888', fontWeight:600, letterSpacing:.8, textTransform:'uppercase', marginBottom:6 }}>{label}{required && ' *'}</label>
      {children}
    </div>
  );
  const inp = { width:'100%', padding:'11px 13px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, color:'#F0EDE8', fontSize:14, outline:'none', boxSizing:'border-box' };

  if (done) return (
    <div style={{ maxWidth:520, margin:'80px auto', padding:'0 24px', textAlign:'center' }}>
      <div style={{ fontSize:64, marginBottom:16 }}>✓</div>
      <h2 style={{ fontSize:28, fontWeight:800, marginBottom:8 }}>Reporte enviado</h2>
      <p style={{ color:'#888', marginBottom:24 }}>Las autoridades han sido notificadas.</p>
      <div style={{ background:'rgba(255,255,255,0.04)', borderRadius:14, padding:20, marginBottom:24, border:'1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ fontSize:11, color:'#555', letterSpacing:1.5, marginBottom:8 }}>NÚMERO DE CASO</div>
        <div style={{ fontSize:24, fontWeight:800, color:'#FF8C00' }}>{done}</div>
      </div>
      <button onClick={() => navigate('/')} style={{ width:'100%', padding:'13px', background:'#FF2D2D', border:'none', borderRadius:12, color:'#fff', fontSize:15, fontWeight:700 }}>Volver al inicio</button>
    </div>
  );

  return (
    <div style={{ maxWidth:680, margin:'0 auto', padding:'40px 24px 80px' }}>
      <h1 style={{ fontSize:28, fontWeight:800, marginBottom:6 }}>Reportar desaparición</h1>
      <p style={{ color:'#888', marginBottom:32, fontSize:14 }}>Los datos serán revisados y publicados en menos de 24h. Para emergencias inmediatas llama al 112.</p>

      {error && <div style={{ background:'rgba(255,45,45,0.1)', border:'1px solid rgba(255,45,45,0.3)', borderRadius:10, padding:12, marginBottom:16, color:'#FF6B6B', fontSize:14 }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <F label="Nombre completo" required>
          <input style={inp} placeholder="Nombre y apellidos" value={form.name} onChange={e=>update('name',e.target.value)} />
        </F>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
          <F label="Edad" required>
            <input style={inp} type="number" placeholder="Años" value={form.age} onChange={e=>update('age',e.target.value)} />
          </F>
          <F label="Género">
            <select style={{ ...inp, cursor:'pointer' }} value={form.gender} onChange={e=>update('gender',e.target.value)}>
              <option>Femenino</option><option>Masculino</option><option>Otro</option>
            </select>
          </F>
        </div>
        <F label="Última ubicación conocida" required>
          <input style={inp} placeholder="Ciudad, dirección o zona" value={form.location} onChange={e=>update('location',e.target.value)} />
        </F>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
          <F label="Fecha desaparición">
            <input style={inp} type="date" value={form.lastSeen} onChange={e=>update('lastSeen',e.target.value)} />
          </F>
          <F label="Hora aproximada">
            <input style={inp} type="time" value={form.lastSeenTime} onChange={e=>update('lastSeenTime',e.target.value)} />
          </F>
        </div>
        <F label="Descripción física">
          <textarea style={{ ...inp, height:100, resize:'none' }} placeholder="Cabello, ojos, altura, ropa, señas particulares..." value={form.description} onChange={e=>update('description',e.target.value)} />
        </F>
        <F label="Tu nombre y relación">
          <input style={inp} placeholder="Ej: María García (madre)" value={form.contactName} onChange={e=>update('contactName',e.target.value)} />
        </F>
        <F label="Teléfono de contacto" required>
          <input style={inp} type="tel" placeholder="+34 600 000 000" value={form.contact} onChange={e=>update('contact',e.target.value)} />
        </F>
        <div style={{ background:'rgba(255,140,0,0.08)', border:'1px solid rgba(255,140,0,0.2)', borderRadius:10, padding:12, marginBottom:20, fontSize:13, color:'#FFB347', lineHeight:1.6 }}>
          ⚠ Al enviar confirmas que la información es veraz. Para emergencias inmediatas llama al 112.
        </div>
        <button type="submit" disabled={loading} style={{ width:'100%', padding:'14px', background:'#FF2D2D', border:'none', borderRadius:12, color:'#fff', fontSize:16, fontWeight:700, opacity:loading?.7:1 }}>
          {loading ? 'Enviando...' : 'Enviar reporte →'}
        </button>
      </form>
    </div>
  );
}
